// extracted by mini-css-extract-plugin
export default {"scoreWrapper":"SportsMatchScoreEditor_scoreWrapper","score":"SportsMatchScoreEditor_score","buttons":"SportsMatchScoreEditor_buttons"};